import { isEmpty } from 'lodash';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBIconV2 } from '@shared/components/image';
import { Colors, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';

interface Props {
  channelName: string;
  query: string;
}

export function QuickCreateCard({ channelName, query }: Props) {
  return (
    <View paddingTop={2}>
      <View row centerVertically>
        <MBIconV2 name="plus" color={Colors.v2.purple} size={grid(4)} />
        <View flex paddingLeft={2}>
          <View row wrap paddingRight={1}>
            <Text size="body1">
              {i18n('card.blocks.cardsInput.createNewCardLabelPrefix')}
              {!isEmpty(query) && <Text weight="semibold">{query}</Text>}
              {i18n('card.blocks.cardsInput.createNewCardLabelSuffix')}
              <Text weight="semibold">{channelName}</Text>
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
}
